import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import './../Popup.css'; // Import your CSS file for styling
import { API_BASE_URL, API_KEY } from '../../constants';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../axios';
import offer from '../../assets/offer.jpg';
function InviteForm({ isOpen,onClose, onInvite, onCancel, onInputChange,loadRazorpayScript,handleWatermarkDownload }) {

  return isOpen ? (
    <div className="popup-overlay">
        <div className="popup" style={{ position: 'relative', padding: '20px', backgroundColor: '#fff', borderRadius: '8px' }}>        <>
        <button onClick={onClose} style={{
          position: 'absolute',
          top: '10px',
          padding: '5px',     // Reduced padding
          width: '30px',      // Explicit button size
          height: '30px',
          lineHeight: '16px', // Align the text inside
          right: '10px',
          backgroundColor: 'transparent',
          border: 'none',
          fontSize: '30px',
          cursor: 'pointer',
          color: '#888',
        }}>
          &times;
        </button>
          <div className="button-container" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            
            {/* Circle with 70% off */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <img src={offer} alt="Your description" style={{
                            width: '100%', // Adjust width as needed
                            maxWidth: '260px', // Set a max width for the image
                            height: 'auto', // Maintain aspect ratio
                            marginBottom: '10px' // Space between image and button
              }} />
              {/* Buy Now button */}
              <button onClick={loadRazorpayScript}>
                Buy Now
              </button>
            </div>
  
            {/* Download with Watermark Button */}
            <a href="#" onClick={(e) => { e.preventDefault(); handleWatermarkDownload(); }}>Continue With Free Download</a>
            </div>
        </>
      </div>
    </div>
  ) : null
  
}

export default InviteForm;
